module.exports = __webpack_public_path__ + "zvetseni-prsou_53_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_53_before.jpg
// module id = 1348
// module chunks = 0